import { Pipe, PipeTransform } from '@angular/core';

import { DateTime } from 'luxon';
import { CONFIG } from '../../config';


/**
 * Transforms the passed date
 * Converts it to UTC, then to the timezone passed by argument, then returns it as the format argument
 */
@Pipe({
    name: 'rmsTzFormat',
    standalone: false
})
export class RmsTzFormatPipe implements PipeTransform {

  transform(value: string, timezone: string = CONFIG.formatEST,
            outputFormat: string = CONFIG.dateTimeServerFormat, inputFormat: string = CONFIG.dateTimeServerFormat): string {
    if (!value) {
      return value;
    }
    try {
      const dt = DateTime.fromFormat(value, inputFormat, { zone: CONFIG.timezoneUTC }).setZone(timezone);
      const formattedValue = dt.toFormat(outputFormat);
      return dt.isValid ? formattedValue : value;
    } catch {
      return value;
    }
  }

}

